const INCREMENT = 'INCREMENT';
const DECREMENT = 'DECREMENT';

export { INCREMENT, DECREMENT };
